import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'CopyButton' })({
    root: {
        padding: '12px 16px',
        borderRadius: 8,
        color: '#FFF',
        transition: 'all 0.2s',
        background: '#353535',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px',
        textTransform: 'none',
        ['&:hover']: {
            background: 'rgba(236, 236, 236, 0.25)'
        },
        ['&:active']: {
            background: 'rgba(236, 236, 236, 0.20)'
        },
        ['& svg']: {
            width: 16,
            height: 16
        }
    }
});
